import { Image as ChakraImage } from '@chakra-ui/react';
import { type FC } from 'react';

import { StyledLink } from '$/components/core/StyledLink';
import { useBlurryImagePreloader } from '$/hooks/useBlurryImagePreloader';
import {
  popularityToImageSize,
  type InspirationWithPopularity,
} from '$/pages/DashboardPages/pages/Inspiration/utils/popularityUtils';

interface Props {
  inspiration: InspirationWithPopularity;
  isDisabled?: boolean;
}

export const InspirationCard: FC<Props> = ({
  inspiration,
  isDisabled = false,
}) => {
  const imageSize = popularityToImageSize(
    inspiration.popularity,
    inspiration.id,
  );

  const props = useBlurryImagePreloader(
    inspiration.thumbnail,
    inspiration.thumbnail,
  );

  return (
    <StyledLink
      to='/inspirations/$id'
      params={{ id: inspiration.id }}
      disabled={isDisabled}
      maxW='100%'
      borderRadius='12px'
      {...imageSize}
    >
      <ChakraImage
        layerStyle='SceneImage'
        w='100%'
        h='100%'
        textColor='transparent'
        _hover={
          !isDisabled
            ? { transform: 'scale(1.02)', transition: 'transform 300ms ease' }
            : {}
        }
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        alt={inspiration.name}
        loading='lazy'
        {...props}
      />
    </StyledLink>
  );
};
